import React, { Component } from "react";
import { Card, CardBody, TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";

import { mealConfigsServiceApi } from "./services/MealConfigServices";
import { toast } from "react-toastify";
import WaterSettingForm from "./WaterSettingForm";
import WaterSettingTable from "./WaterSettingTable";
import ManagedFoodMetric from "./ManagedFoodMetric";
class ManageMealConfigs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: "1",
            submitted: false,
            submitting: false,
            formResponse: null,
            formError: null,
            error: null,
            selectedRow: null,
            hasParams: false,
            pageNum: 0,
            pageSize: 2,
            pages: null,
            fetching: false,
            data: null,
        };
    }
    toggle = (tab) => {
        const { activeTab } = this.state;
        if (activeTab !== tab) {
            this.setState({ activeTab: tab });
        }
    };

    getHydrationSetting = async () => {
        this.setState({ fetching: true });
        try {
            let response = await mealConfigsServiceApi.getWaterConfig();
            if (response) {
               
                let arry = [];
                arry.push(response.data);
                this.setState({
                    error: null,
                    fetching: false,
                    data: arry,
                });
            }
        } catch (error) {
            this.setState({ error, fetching: false });
        }
    };
    setHydrationSetting = async (data) => {
        this.setState({
            ...this.state,
            submitting: true,
            submitted: false,
            formResponse: null,
            formError: null,
        });
        try {
            let response = await mealConfigsServiceApi.setWaterConfig(data);
            if (response) {
            
                toast.success("Hydration value set successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                });

                this.setState({
                    ...this.state,
                    submitting: false,
                    submitted: true,
                    formResponse: null,
                    formError: null,
                });
                //do a refectch to the table.
                this.getHydrationSetting();
            }
        } catch (error) {
            this.setState({
                ...this.state,
                formError: error,
                submitting: false,
            });
        }
    };

    componentDidMount() {
        //get the data for the water config...
        this.getHydrationSetting();
    }

    handleSubmit = (data) => {
     
        this.setHydrationSetting(data);
    };

    render() {
        const { activeTab, submitted, submitting, formError, pages, pageNum, pageSize, fetching, data, error, selectedRow, hasParams } = this.state;

        return (
            <div>
                <Card>
                    <CardBody>
                        <Nav tabs className="mb-3">
                            <NavItem>
                                {" "}
                                <NavLink
                                    className={classnames({ active: activeTab === "1" })}
                                    style={{
                                        cursor: "pointer",
                                    }}
                                    onClick={() => this.toggle("1")}
                                >
                                    {"Hydration Setting"}
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({ active: activeTab === "2" })}
                                    style={{
                                        //borderColor: " #1B415D #1B415D #fff ",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => this.toggle("2")}
                                >
                                    {"Food Metric Setting"}
                                </NavLink>
                            </NavItem>
                        </Nav>

                        <TabContent activeTab={activeTab}>
                            <TabPane tabId="1">
                                <section className={"mb-3"}>
                                    <WaterSettingForm handleSubmit={this.handleSubmit} formError={formError} submitted={submitted} submitting={submitting} />
                                </section>
                                <section>
                                    <WaterSettingTable
                                        fetching={fetching}
                                        hasParams={hasParams}
                                        selectedRow={selectedRow}
                                        data={data}
                                        pages={pages}
                                        page={pageNum}
                                        pageSize={pageSize}
                                        error={error}
                                        filterData={this.filterData}
                                        setPageNumber={this.setPageNumber}
                                        setPageSize={this.setPageSize}
                                        selectRow={this.editFoodItems}
                                    />
                                </section>
                            </TabPane>
                            <TabPane tabId="2">
                                <ManagedFoodMetric />
                            </TabPane>
                        </TabContent>
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default ManageMealConfigs;
